angular.module('SpidApp')

.constant('CashAdapterConfig', {
  name : 'Cash',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'vacation_id',
    	distant : 'vacation_id'
    }, {
    	local   : 'state',
    	distant : 'state'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }, {
        local   : 'agency_id',
        distant : 'agency_id'
    }
  ]
})
